import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { id: "header-wrapper" }
const _hoisted_3 = { class: "main-content pt-1 pt-lg-5" }

import { computed, ComputedRef, onMounted } from 'vue'
  import { useStore } from 'vuex'

  // Components
  import SlidingPanel from './components/UI/SlidingPanel.vue'
  import BookingPanel from '@/components/common/BookingPanel.vue'
  import LocaleSelector from '@/components/UI/LocaleSelector.vue'
  import StickyBar from '@/components/ConfirmedReservations/BookingPanel/StickyBar.vue'

  // Config
  import { ModalId } from '@/config/modalIds'
  import { CookieName } from '@/config/cookies'

  // Cookies
  import Cookies from 'js-cookie'

  // Types
  import { CompanyLang, Locale } from '@/types'

  // Router
  import { useRoute } from 'vue-router'
  import { RouteConfig } from './config'

  // Composables
  import useDocumentTitle from "@/composables/useDocumentTitle"
  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const {setDocumentTitle} = useDocumentTitle()

  const store = useStore()
  const route = useRoute()

  // computed
  const selectedBooking = computed(
    () => store.getters['booking/selectedBooking']
  )

  // Methos
  const onClose = (): void => {
    store.dispatch('booking/unselectBooking')
    store.commit('modal/close', ModalId.BOOKING_PANEL)
  }

  // Get the panel visibility state from Vuex
  const isPanelVisible = computed(() => {
    const checkIsOpen = store.getters['modal/isOpen']

    return checkIsOpen(ModalId.BOOKING_PANEL)
  })

  const locale: ComputedRef<Locale> = computed(() => {
    return store.getters.getLocale
  })

  const displayLocaleSelector: ComputedRef<boolean> = computed(() => {
    const companyLang = Cookies.get(CookieName.COMPANY_LANG) as
      | CompanyLang
      | undefined
    const company = Cookies.get(CookieName.COMPANY) as string | undefined
    return (
      locale.value === 'fr-FR-CSE' &&
      !companyLang &&
      !company &&
      route.path === `/account/${RouteConfig.LOGIN}`
    )
  })


  onMounted(() => {
    setDocumentTitle()
  })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (displayLocaleSelector.value)
        ? (_openBlock(), _createBlock(LocaleSelector, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(SlidingPanel, {
      isPanelVisible: isPanelVisible.value,
      onClose: onClose
    }, {
      bottom: _withCtx(() => [
        _createVNode(StickyBar, { booking: selectedBooking.value }, null, 8, ["booking"])
      ]),
      default: _withCtx(() => [
        _createVNode(BookingPanel)
      ]),
      _: 1
    }, 8, ["isPanelVisible"]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "footer-wrapper" }, null, -1))
  ]))
}
}

})